import React from 'react';
var ButtonGroup = function (_a) {
    var children = _a.children, style = _a.style;
    return React.createElement("div", { style: style }, children);
};
export default ButtonGroup;
